var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item',{attrs:{"link-classes":"btn-navbar"},on:{"click":_vm.toggleNotificationList}},[_c('i',{staticClass:"fas fa-bell mr-0 text-white",staticStyle:{"font-size":"18px"}}),(_vm.count)?_c('div',{staticClass:"nav-link__badge"},[_c('span',[_vm._v(_vm._s(_vm.count))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }